import request from "@/utils/request";
import { apiConfig } from "../config/api";

export function resume(userId) {
  return request({
    url: apiConfig.openApi.api.resume.url,
    method: "get",
    params: {
      userId: userId
    }
  });
}
export function queryCertificate(params) {
  return request({
    url: apiConfig.openApi.api.queryCertificate.url,
    method: "get",
    params: params
  });
}
